import { LabelNames } from "../shared/core/ovs.core";

export class ResortCheckoutLabelNames {
    public static VCAccordion = 'resort_checkout_page_vc_accordion';
    public static VCAccordionUsed = 'resort_checkout_page_vc_used';
    public static VCAccordionBalance = 'resort_checkout_page_vc_balance';
    public static Total = LabelNames.TotalPrice;
    public static SoftCurrencySymbol = 'soft_currency_symbol';
    public static ResortConfirmationVcLabel = 'resort_confirmation_vc_label';
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/check-out/resort-checkout-label-names.ts